module.exports = __webpack_public_path__ + "static/media/iphone.b6074571.png";